import React, { useEffect, useState } from 'react';
import Header from '../layouts/Header';
import Banner from '../components/service/Banner';
import Footer from '../layouts/Footer';
import JoinOurTeam from '../components/Home/JoinOurTeam';
import CommonDesign from '../components/service/commonDesign';
import Features from '../components/service/Features';
import Skills from '../components/service/Skills';
import { Col, Container, Row } from 'react-bootstrap';
import { motion } from "motion/react";
import { Helmet } from "react-helmet";

const TrainingPage = () => {
    const [hasLoaded, setHasLoaded] = useState(false);
    useEffect(() => {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
      const timer = setTimeout(() => setHasLoaded(true), 100);
      return () => clearTimeout(timer);
    }, []);

   const titleData = {
    service_name: "OUR TRAINING",
    title: "Build Skills.Build Confidence.",
    content: "Optimise your workforce with expert-curated training programs that address today's challenges and prepare them for tomorrow's opportunities."
  }
  const featureData = {
    service_name: "OUR TRAINING",
    title: "Who Do We Cater To?",
    list: [
      {
        icon: "/images/enterprises1.svg",
        title: "Enterprises",
        content: "Upskill entire teams for large-scale transformation."
      },
      {
        icon: "/images/size-businesses.svg",
        title: "Small & Medium Businesses",
        content: "Upskill entire teams for large-scale transformation."
      },
      {
        icon: "/images/it.svg",
        title: "Information Technology(IT)",
        content: "Equip developers, analysts, and engineers with future-ready expertise."
      },
      {
        icon: "/images/leadership.svg",
        title: "Leadership",
        content: "Drive innovation with advanced management and strategic training."
      },
      {
        icon: "/images/graduates.svg",
        title: "Graduates",
        content: "Prepare newcomers with industry-relevant, job-ready skills."
      },
    ] 
  }
  const skillData = {
    list: [
      {
       icon: "/images/corporate-training.svg",
       subheading: "CORPORATE TRAINING",
       title: "Equip your team with industry-leading skills.",
       content: "Equip your team with industry-relevant skills through customized corporate training. Our expert-led sessions tackle business challenges and drive long-term success."
       }, 
       {
        icon: "/images/training-on-demand.svg",
        subheading: "TRAINING ON DEMAND",
        title: "Upskill on the go with expert-led sessions.",
        content: "Unlock high-quality training anytime with our on-demand learning solutions. Flexible and tailored, our programs keep employees ahead in today’s fast-changing business world."
        }, 
        {
          icon: "/images/training-marketplace.svg",
          subheading: "TRANING MARKETPLACE",
          title: "Discover courses for every industry.",
          content: "Explore a diverse range of industry courses in our training marketplace, from technology to leadership. Empower your teams with future-ready skills through expertly curated, real-world content."
          }
    ]
  }
  return (
    <motion.div
  initial={{ opacity: 0 }}
  animate={{ opacity: hasLoaded ? 1 : 0 }}
  transition={{ duration: 0.7 }}
>
  <Helmet>
    <title>Volto Consulting | Business &amp; Technology Solutions</title>
    <meta
      name="description"
      content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
    />
    <meta
      name="keywords"
      content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
    />
    <meta name="author" content="Volto Consulting" />
    <meta
      property="og:title"
      content="Volto Consulting | Business &amp; Technology Solutions"
    />
    <meta
      property="og:description"
      content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
    />
  </Helmet>

  <div className="volto-homepage service ">
    <Header />

    <Banner 
    mode="dark"
    bannerImg="/images/training-banner.webp"
    title="Empowering Growth "
    main_content="Training is costly and time-consuming. Partner with Volto to build skilled teams that match your evolving business needs."
    />
    <div className="linear-gradient">
      <CommonDesign data={titleData} />
      <Skills data={skillData} />
    </div>

    <Container className="volto-section">
      <Row>
        <Col lg={6}>
          <img
            className="img-fluid"
            src="/images/learning-and-growth-vector.svg"
            alt="learning-and-growth-vector"
          />
        </Col>
        <Col>
          <img
            className="img-fluid"
            src="/images/training-process.svg"
            alt="training-process"
          />
        </Col>
      </Row>
    </Container>
    <Features data={featureData} />
    <JoinOurTeam image="/images/join-our-team.webp" />
    <Footer />
  </div>
</motion.div>

  )
}

export default TrainingPage;
